export default __webpack_public_path__ + "static/media/hessahStore1.617b758e.jpg";